import { PhoneOutlined } from "@ant-design/icons";
import "./SelfCampaignSupportBar.scss";

const SelfCampaignSupportBar: React.FC = () => {
  return (
    <div className="self-campaign-support-bar">
      <div className="self-campaign-support-bar__content">
        <PhoneOutlined />
        <span>Need help?</span>
        <a href="#book-call">Book A Call</a>
      </div>
    </div>
  );
};

export default SelfCampaignSupportBar;
